import SecuritySection from '../components/SecuritySection';
import { useLanguage } from '../i18n/LanguageContext';

const SecurityPage = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="security-page">
      {/* Page Header */}
      <section className="py-16 md:py-20 bg-white border-b border-slate-200">
        <div className="container-max px-6 md:px-12 lg:px-24">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-testid="security-page-title">
              {t('security.pageTitle')}
            </h1>
            <p className="text-lg text-slate-600" data-testid="security-page-subtitle">
              {t('security.pageSubtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Full Security Content */}
      <SecuritySection />
    </div>
  );
};

export default SecurityPage;
